let userProfileId = "";
export const getUserProfileId = () => {
    return userProfileId;
};
export const setUserProfileId = (id) => {
    if (typeof id !== "string" || id.trim() === "") {
        throw new Error("Invalid user profile ID. It must be a non-empty string.");
    }
    userProfileId = id;
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/user/user-store.js
// module id = ./node_modules/@celine/passive-tracking/dist/user/user-store.js
// module chunks = 0